<template>
  <!-- 账号管理设置页面 -->
  <!-- 设置页面的内容区域 -->
  <!-- // 代号 20241212-1  整页-->
  <div class="config_main_manage_page_wraper">
    <div class="config_main_manage_page_content">
      <!-- 设置页面  内容区域样式   以上部分都是公共样式 -->
      <config-hang @click.native="deviceSet('changeRemark')">
        <span slot="config_hang_ele2">修改设备备注</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
      <config-hang v-if="query.type == 'offLine'" @click.native="deviceSet('replace')">
        <span slot="config_hang_ele2">替换设备</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
      <config-hang v-if="query.type == 'onLine'" @click.native="deviceSet('changeAddress')">
        <span slot="config_hang_ele2">修改设备地址</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
      <config-hang @click.native="openResendPage('productConfigResend')">
        <span slot="config_hang_ele2">配置数据补发</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
      <config-hang @click.native="openResendPage('productSceneResend', 'RELATED')">
        <span slot="config_hang_ele2">关联场景补发</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
      <config-hang @click.native="openResendPage('productSceneResend', 'ALL')">
        <span slot="config_hang_ele2">全部场景补发</span>
        <img slot="config_hang_ele4" src="~assets/img/config/youjiantou.png" alt />
      </config-hang>
    </div>
  </div>
</template>

<script>
import configHang from "components/common/config/config-hang";
import configTitleHang from "components/common/config/config-title-hang";
export default {
  data() {
    return {
      oneHostDeviceListData: {
        ////服务器请求到的主机下面的设备列表
        offLineList: [],
        onLineList: [],
        threadNewProductList: []
      },
      oneHostData: {
        ////一个主机的信息
      },
      query: {}
    };
  },
  components: {
    configHang,
    configTitleHang
  },
  methods: {
    openResendPage(path, scope) {
      this.$router.push({ path: path, query: Object.assign({}, this.query, scope ? { scope: scope } : {}) });
    },
    deviceSet(type) {
      this.query.type = this.query.type + type;
      console.log("改变设备地址或备注!" + this.query.type);
      if (type == 'replace') {
        this.$router.push({
          path: "threadDeviceReplace",
          query: this.query
        });
      } else {
        console.log(this.query);
        this.$router.push({
          path: "threadAddNewDevice",
          query: this.query
        });
      }


    }

  },
  computed: {
  },
  mounted() {
    console.log("mounted阶段");
  },
  created() {
    console.log("created阶段");
    this.query = this.$route.query;
    this.oneHostData = this.$store.state.configinfo.oneHostData; ///拿到仓库当前主机的信息
    this.oneHostDeviceListData = this.$store.state.configinfo.oneHostDeviceListData; ///拿到仓库当前主机下的设备列表
    console.log(this.query);
    console.log(this.oneHostData);
    console.log(this.oneHostDeviceListData);
    //  this.$forceUpdate()  ////强制更新视图
  }
};
</script>

<style>
.device_go_online_btn_corol {
  color: var(--primary-color);
}
</style>
